<div class="container">
    <p>
        <b>Spatial Query Tool</b> - Select primary layers containing the features you are interested in, then select
        joining layers to filter down those features. You may either query those features that physically overlap the
        joining layers (intersect), or those that appear outside the joined layers (difference). Copies of your primary
        layers are created by default, but in step 4 you can choose to apply the spatial join filter to the original
        primary layers instead.
    </p>


    <div class="well">
        <div class="steps-container">
            <span class="steps-label">Step 1</span>
        </div>
        <div class="form-group">
            <div style="width: 18%; display: inline-block;">
                <label class="col-sm-3 control-label" style="display: inline-block; margin-bottom: 5px; padding: 10px; font-weight:bold;">Select Primary Layers: </label>
            </div>
            <div style="width: 82%; display: inline-block;">
                <mc-select-ng controlLabel="Primary layers"
                              [data]="primaryLayerList"
                              isMultiSelect="true"
                              isSearchable="true"
                              label="name"
                              [(model)]="selectedPrimaryLayers"
                              (modelChange)="setPrimaryLayers()"
                              placeholderText="Choose primary layers"
                              value="id">
                </mc-select-ng>
            </div>
        </div>

        <div class="steps-container">
            <span class="steps-label">Step 2</span>
        </div>
        <div class="form-group">
            <div style="width: 18%; display: inline-block;">
                <label class="control-label" style="display: inline-block; margin-bottom: 5px; padding: 10px; font-weight: bold;">Select Joining Layers: </label>
            </div>
            <div style="width: 82%; display: inline-block;">
                <mc-select-ng controlLabel="Joined layers"
                              [data]="joinedLayerList"
                              [isDisabled]="filteredGeometryString !== ''"
                              isMultiSelect="true"
                              isSearchable="true"
                              label="name"
                              [(model)]="selectedJoinedLayers"
                              (modelChange)="setJoinedLayers()"
                              placeholderText="Choose joined layers"
                              value="id">
                </mc-select-ng>
            </div>
            <div style="width: 15%; display: inline-block;"> </div>
            <div style="width: 85%; display: inline-block;">
                <span>-- OR --</span>
            </div>
            <div>
                <mc-geographic-filter-ng #geographicFilter id="geographicFilter" [updateLayerOnApply]="false" [mapView]="mapView" ></mc-geographic-filter-ng>
            </div>
            <div *ngIf="graphicsObject.length > 0" style="display: inline-block; margin-bottom: 5px; padding: 10px;">
                <input type="checkbox" [(ngModel)]="drawBoundary" />
                <span>Boundary as drawing layer</span>
            </div>
        </div>
        <div class="steps-container">
            <span class="steps-label">Step 3</span>
        </div>
        <div class="form-group">
            <div style="width: 15%; display:inline-block;">
                <label class="col-sm-3 control-label" style="display: inline-block; margin-bottom: 5px; padding: 10px; font-weight: bold;">Operation: </label>
            </div>
            <div style="width: 85%; display:inline-block;">
                <select class="modifier-class" style="display:inline-block;" [(ngModel)]="isIntersect">
                    <option *ngFor="let option of queryOptions" [ngValue]="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>
            <div style="display:inline-block; margin-left: 10px;">
                <input style="display: inline-block; padding: 10px;" class="col-sm-3 control-label" type="checkbox" [checked]="srMatch" [(ngModel)]="srMatch">
            </div>
            <div style="display:inline-block;">
                <label style="display:inline-block;">SR Matching</label>
            </div>
        </div>

            <div class="steps-container">
                <span class="steps-label">Step 4</span>
            </div>
            <div class="form-group">
                <div style="width: 15%; display:inline-block;">
                    <label class="col-sm-3 control-label" style="display: inline-block; margin-bottom: 5px; padding: 10px; font-weight: bold;">Output Options: </label>
                </div>
                <div style="width: 85%; display:inline-block;">
                    <select class="modifier-class" style="display:inline-block;" [(ngModel)]="newLayer">
                        <option *ngFor="let option of layerOptions" [ngValue]="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                </div>
            </div>

        </div>
    <div>
        <div class="steps-container">
            <span class="steps-label">Advanced Options</span>
        </div>
        <div class="radio-group-container" style="margin-left: 15px">
            <fieldset class="radio-group">
                <input class="radio-group-input" type="radio" id="rbtnDefault" [ngModel]="processingType" value="Default" />
                <label class="radio-group-label" for="type" (click)="setProcessingType('Default')">
                    Auto
                </label>
                <input class="radio-group-input" type="radio" id="rbtnSpatialGP" [ngModel]="processingType" value="GPProcess" />
                <label class="radio-group-label" for="type" (click)="setProcessingType('GPProcess')">
                    Force Spatial GP Process
                </label>
                <input class="radio-group-input" type="radio" id="rbtnOracleSDO" [ngModel]="processingType" value="OracleSDO" />
                <label class="radio-group-label" for="type" (click)="setProcessingType('OracleSDO')">
                    Force Oracle SDO
                </label>
            </fieldset>
            <div class="radio-group">
                <label *ngIf="processingType==='Default'">Auto will perform an RMS attribute join if layers have RMS/LRS attributes.  If not, the spatial query tool will use the GP Process for point and line joined layers or Oracle SDO for polygon joined layers.</label>
                <label *ngIf="processingType==='GPProcess'">ArcGIS GP process on point and line layers</label>
                <label *ngIf="processingType==='OracleSDO'">Oracle SDO process on all layers</label>
            </div>
        </div>
    </div>
    <div *ngIf="showLoader" class="loader is-active">
        <div class="loader-bars"></div>
        <div class="loader-text"> Executing...</div>
    </div>

    <button class="btn right" (click)="close()">Cancel</button>
    <button class="btn right" [disabled]="disable" (click)="runSpatialQuery()" style="margin-right: 8px;">
        Execute
    </button>
</div>
